import React from 'react'
import Contactoportada from '../components/contacto/contactoportada'
import ContactoForm from '../components/contacto/contactoForm'
import ContactoMaps from '../components/contacto/contactomaps'


const Contacto = () => {
  return (
    <>
    
    <Contactoportada/>
    <ContactoForm/>
    
    <ContactoMaps/>
    </>
  )
}

export default Contacto